import { Divider, Text, Box, Heading } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CellValue } from 'react-table';

import { FloatingHeadTable } from 'components/Table';
import ExportMenu from 'containers/Reports/shared/ExportMenu';
import useStickyHeader from 'containers/Reports/shared/useStickyHeader';
import { formatYearMonthDayTime } from 'utils/format';

interface IBreakReportsTable {
  data: any;
  dateRange: any[];
}

const BreakReportsTable: React.FC<IBreakReportsTable> = ({ data, dateRange }) => {
  const { t } = useTranslation(['common', 'reports']);
  useStickyHeader();

  const columns = useMemo(
    () => [
      {
        Header: t('common:name'),
        accessor: 'name',
      },
      {
        Header: t('reports:shiftStart'),
        width: 200,
        accessor: 'start_shift',
        Cell: (data: CellValue) => <Text>{data.value ? formatYearMonthDayTime(data.value) : '-'}</Text>,
      },
      {
        Header: t('reports:shiftEnd'),
        width: 200,
        accessor: 'end_shift',
        Cell: (data: CellValue) => <Text>{data.value ? formatYearMonthDayTime(data.value) : '-'}</Text>,
      },
      {
        Header: t('common:type'),
        width: 200,
        accessor: 'break_name',
        Cell: (data: CellValue) => <Text>{data.value || '-'}</Text>,
      },
      {
        Header: t('common:duration'),
        accessor: 'duration',
        Cell: (data: CellValue) => <Text>{data.value || '-'}</Text>,
      },
      {
        Header: t('reports:breakStart-BreakEnd'),
        width: 200,
        accessor: 'breakStartToEnd',
        Cell: (data: CellValue) => <Text>{data.value || '-'}</Text>,
      },
    ],
    [t]
  );

  return (
    <>
      <Divider my="4" />
      <Box p="4">
        <Heading variant="h2" size="md" fontWeight="semibold" mb="4">
          {t('reports:searchResults')}
        </Heading>
        {data?.payload?.attributes ? (
          <ExportMenu dateRange={dateRange} attributes={data?.payload?.attributes} reportType="byBreak" />
        ) : null}
        <FloatingHeadTable columns={columns} data={data?.payload?.breaks || []} />
      </Box>
    </>
  );
};

export default BreakReportsTable;
